import React from 'react';
import { IconProps } from '@/icons/icon';

const Fondo: React.FC<IconProps> = () => {
  return (
    <svg
      width="100%" // Permite que el SVG se expanda en todas las pantallas
      height="100%"
      viewBox="0 0 1920 1080" // Mantiene la relación de aspecto
      preserveAspectRatio="xMidYMid slice" // Ajusta el contenido al viewport sin distorsión
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_53_35)">
        <path
          d="M-252.024 653.013C-252.024 653.013 262.974 784.891 816.415 631.736C1369.86 478.596 1515.89 367.994 1992.48 499.858L2049 1724.34H-257L-252.024 652.999V653.013Z"
          // fill="var(--darken-primary-color)"
          fill="var(--primary-color)"
        />
        <mask
          id="mask0_53_35"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="274"
          width="1931"
          height="493"
        >
          <path
            d="M0.133789 699.095C12.7276 698.561 25.462 697.788 38.3651 696.817C25.1247 691.473 12.3762 685.961 0.133789 680.336V699.109V699.095ZM833.422 526.225C730.914 544.323 631.443 567.414 536.469 595.427C417.825 630.414 215.536 683.359 38.3651 696.817C266.362 788.659 644.908 828.639 1206.54 559.23C1283.41 522.358 1354.91 489.466 1421.29 460.23C1267.6 463.816 1075.22 483.545 833.436 526.225M1421.29 460.23C1691.05 453.93 1841.52 497.369 1930.28 553.703V274C1807.28 305.612 1642.38 362.819 1421.29 460.23Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_53_35)">
          <path
            // fill="var(--primary-color)"
            fill="var(--light-primary-color)"
            d="M1930.28 273.986H0.133789V828.639H1930.28V273.986Z"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_53_35"
          x1="-261.691"
          y1="549.881"
          x2="2275.38"
          y2="549.881"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1798D5" />
          <stop offset="0.64" stopColor="#20B8E4" />
          <stop offset="1" stopColor="#24C4EA" />
        </linearGradient>
        <clipPath id="clip0_53_35">
          <rect width="1920" height="1080" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Fondo;
